import { EmbeddableCatalogBrowserWithRouter } from '@tableau/data-catalog-client-components';
import * as React from 'react';
import { connect } from 'react-redux';
import { mapStateToSiteUrlsProps, SiteUrlsProps } from '../app/selectors/SiteUrlsSelectors';
import { ServiceLocator } from '../app/ServiceLocator';
import { angularProviderHOC } from '../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../ts/directives/reactDirectiveFactory';
import { DatabaseDefinition, TableDefinition } from '../ts/models/ContentDefinitions';
import { DatabaseContentType, TableContentType } from '../ts/models/ContentTypes';
import { DataCatalogApiRequestsService } from '../ts/services/DataCatalogApiRequestsService';
import { DataCatalogUIActionsService } from '../ts/services/DataCatalogUIActionsService';
import { Telemetry } from '../ts/services/TelemetryService';
import { catalogApolloClient } from './CatalogApolloClient';
import { CatalogBrowserSubspaceExplorer } from './CatalogBrowserSubspaceExplorer';
import { registerErrorStore, unregisterErrorStore } from './CatalogErrorReporterService';

type CatalogBrowserHostOwnProps = ReactDirectiveProps;
type CatalogBrowserHostProps = SiteUrlsProps & CatalogBrowserHostOwnProps & CatalogBrowserAngularProvider.PropsFromAngular;


class CatalogBrowserHost extends React.Component<CatalogBrowserHostProps> {

  private renderDatabasesExplorer = (routeLocationSearch: string): JSX.Element => {
    return <CatalogBrowserSubspaceExplorer
      key="database"
      subspaceName="database"
      routeLocationSearch={routeLocationSearch}
      angularContext={this.props.angularContext}
      contentDefinition={DatabaseDefinition}
      contentType={DatabaseContentType}
      telemetry={this.props.telemetry}
    />;
  }

  private renderTablesExplorer = (routeLocationSearch: string): JSX.Element => {
    return <CatalogBrowserSubspaceExplorer
      key="table"
      subspaceName="table"
      routeLocationSearch={routeLocationSearch}
      angularContext={this.props.angularContext}
      contentDefinition={TableDefinition}
      contentType={TableContentType}
      telemetry={this.props.telemetry}
    />;
  }

  public render(): JSX.Element {
    return (
      <div className="tb-fill" style={{ display: 'flex' }}>
        <EmbeddableCatalogBrowserWithRouter
          client={catalogApolloClient}
          siteUrls={this.props.urls}
          apiRequests={this.props.apiRequestsService}
          uiActions={DataCatalogUIActionsService.instance()}
          renderDatabasesExplorer={this.renderDatabasesExplorer}
          renderTablesExplorer={this.renderTablesExplorer}
          registerErrorStore={registerErrorStore}
          unregisterErrorStore={unregisterErrorStore}
        />
      </div>
    );
  }
}

namespace CatalogBrowserAngularProvider {

  export type AngularServices = {
    readonly apiRequestsService: DataCatalogApiRequestsService;
    readonly telemetry: Telemetry;
  };

  export type PropsFromAngular = AngularServices;

  function getAngularServicesWithServiceLocator() {
    const apiRequestsService = ServiceLocator.get<DataCatalogApiRequestsService>('DataCatalogApiRequestsService');
    const telemetry = ServiceLocator.get<Telemetry>('TelemetryService');
    return { apiRequestsService, telemetry };
  }

  export const HOC = angularProviderHOC<CatalogBrowserHostOwnProps & SiteUrlsProps, PropsFromAngular, AngularServices>({
    getAngularServicesWithServiceLocator,
    selectPropsFromAngularServices: angularServices => angularServices,
  });
}

export const WrappedCatalogBrowserHost =
  connect(mapStateToSiteUrlsProps)(
    CatalogBrowserAngularProvider.HOC(
      CatalogBrowserHost
    )
  );
